// import logo from "./logo.svg";
// import "./App.css";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "./Component/Login/login";
// import AppLayout from "./Component/layout";
// import Ticket from "./pages/allTickets";
// import { useState } from "react";
// import ForgotPassword from "./Component/Login/forgotPassword";
// import VerifyOTP from "./Component/Login/VerifyOtpComp";
// import ChangePassword from "./Component/Login/changePassword";
// import TicketInfo from "./pages/ticketInfo";
// import MeetingNotesList from "./pages/meetingNotesList";
// import MeetingNote from "./pages/meetingNote";
// import ViewBroadCast from "./pages/viewBroadCast";
// import BroadcastInfo from "./pages/broadCastInfo";


// function App() {
//   const [currentPage, setCurrentPage] = useState("login");

//   const renderPage = () => {
//     switch (currentPage) {
//       case "login":
//         return <Login setCurrentPage={setCurrentPage} />;
//       case "resetPassword":
//         return <ForgotPassword setCurrentPage={setCurrentPage} />;
//       case "verifyOtp":
//         return <VerifyOTP setCurrentPage={setCurrentPage} />;
//       case "changePassword":
//         return <ChangePassword setCurrentPage={setCurrentPage} />;
//       default:
//         return <Login setCurrentPage={setCurrentPage} />;
//     }
//   };

//   return (
//     <Router basename="/dev" >
//       <Routes>
//         <Route path="/login" element={renderPage()} />
        

//         <Route path="/" element={<AppLayout />}>
//           <Route index element={<Ticket />} />
//           <Route path="/ticket-info" element={<TicketInfo />} />
//           <Route path="/meeting-notes" element={<MeetingNotesList />} />
//           <Route path="/broadcast-info" element={<BroadcastInfo/>} />
//           <Route path="/meeting-info" element={<MeetingNote />} />
//           <Route path="/view-broadcast" element={<ViewBroadCast />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Suspense, useState, lazy } from "react";

const Login = lazy(() => import("./Component/Login/login"));
const ForgotPassword = lazy(() => import("./Component/Login/forgotPassword"));
const VerifyOTP = lazy(() => import("./Component/Login/VerifyOtpComp"));
const ChangePassword = lazy(() => import("./Component/Login/changePassword"));
const AppLayout = lazy(() => import("./Component/layout"));
const Ticket = lazy(() => import("./pages/allTickets"));
const TicketInfo = lazy(() => import("./pages/ticketInfo"));
const MeetingNotesList = lazy(() => import("./pages/meetingNotesList"));
const MeetingNote = lazy(() => import("./pages/meetingNote"));
const ViewBroadCast = lazy(() => import("./pages/viewBroadCast"));
const BroadcastInfo = lazy(() => import("./pages/broadCastInfo"));
const Calendly = lazy(() => import("./pages/calendly"));
const Questionarre = lazy(()=> import("./pages/questionarre"))
const QuestionareDetails = lazy(()=>import("./pages/questionareDetails"))
const MutualFund = lazy(()=> import("./pages/mutualFund"));
const ViewTransaction = lazy(() => import("./pages/viewTransaction"));
const Notification = lazy(()=> import("./pages/notification"))
const Ratings = lazy (()=> import("./pages/ratings"))
const Faq = lazy (() => import("./pages/faq"));
const Customer = lazy (() => import ("./pages/customer"))
const Feature = lazy (() => import ("./pages/feature"))
const Api = lazy (() => import ("./pages/api"))
const DirectMutualFunds = lazy (() => import ("./pages/directMutualFunds"))

function App() {
  const [currentPage, setCurrentPage] = useState("login");

  const renderPage = () => {
    switch (currentPage) {
      case "login":
        return <Login setCurrentPage={setCurrentPage} />;
      case "resetPassword":
        return <ForgotPassword setCurrentPage={setCurrentPage} />;
      case "verifyOtp":
        return <VerifyOTP setCurrentPage={setCurrentPage} />;
      case "changePassword":
        return <ChangePassword setCurrentPage={setCurrentPage} />;
      default:
        return <Login setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <Router >
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={renderPage()} />

          <Route path="/" element={<AppLayout />}>
            <Route index element={<Ticket />} />
            <Route path="/ticket-info" element={<TicketInfo />} />
            <Route path="/meeting-notes" element={<MeetingNotesList />} />
            <Route path="/broadcast-info" element={<BroadcastInfo />} />
            <Route path= "/questionare-details" element={<QuestionareDetails/>}/>
            <Route path = "/view-traxns" element={<ViewTransaction/>}/>
            
            <Route path="/meeting-info" element={<MeetingNote />} />
            <Route path="/view-broadcast" element={<ViewBroadCast />} />
            <Route path="/view-calendly" element={<Calendly />} />
            <Route path ="/questionarre" element={<Questionarre/>} />
            <Route path="/mutual-fund" element={<MutualFund/>}/>
            <Route path="/notification" element={<Notification/>}/>
            <Route path= "/rm-ratings" element={<Ratings/>}/>
            <Route path = "/faq" element={<Faq/>}/>
            <Route path = "/customer" element={<Customer/>}/>
            <Route path ="/feature" element={<Feature/>}/>
            <Route path ="/api" element={<Api/>}/>
            <Route path ="/direct-mutual-funds" element={<DirectMutualFunds/>}/>
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
